var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8496 1L0.999817 20.798",
    stroke: "#BDC7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20264 1.20215L21.0524 21.0001",
    stroke: "#BDC7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThin);
export default __webpack_public_path__ + "static/media/cross-thin.796964704f59f0f992ae18ae546ec4a9.svg";
export { ForwardRef as ReactComponent };